import React, { useState } from 'react';

import { List as UIList, ListItem, ListItemText } from '@material-ui/core';
import { ExpandMoreRounded } from '@material-ui/icons';
import { navigate } from '@reach/router';

import { ISeason } from '../../../../../store/seasons/store';

import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';

interface IPlayerSeasonSelector {
  clubSeasons: ISeason[];
  currentSeason?: ISeason;
  clubId: string;
  section: 'standings' | 'events';
}

export const PlayerSeasonSelector = (props: IPlayerSeasonSelector) => {
  const { clubId, clubSeasons, currentSeason, section } = props;

  const [isOpen, toggleOpen] = useState(false);

  const setSeason = (seasonId: string) => () => {
    navigate(`/club/${clubId}/${section}/${seasonId}`);
    toggleOpen(false);
  };

  return (
    <>
      <Button onClick={() => toggleOpen(!isOpen)} className="season-select">
        {currentSeason && currentSeason.year} SEASON
        <ExpandMoreRounded className="arrow-down" color="primary" />
      </Button>

      <Modal
        onClose={() => toggleOpen(!isOpen)}
        className="player-scope"
        open={isOpen}
        title="SEASON"
      >
        <UIList className="select-list">
          {clubSeasons.map(option => (
            <ListItem
              className="select-item"
              button={true}
              onClick={setSeason(String(option.id))}
              id={`option-${option.id}`}
              key={`option-${option.id}`}
            >
              <ListItemText primary={option.year} />
            </ListItem>
          ))}

          <ListItem
            className="select-item"
            button={true}
            onClick={setSeason('All')}
            id={`option-all`}
          >
            <ListItemText primary="All" />
          </ListItem>
        </UIList>
      </Modal>
    </>
  );
};
